/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CmisProperty { 
    propertyDefinitionId?: string;
    localName?: string;
    name?: string;
    displayName?: string;
    queryName?: string;
    otherAttributes?: { [key: string]: string; };
}

